<script setup>
  defineOptions({ name: "PlusIcon" });
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 7.001H9V1.001C9 0.449 8.552 0 8 0S7 0.449 7 1.001v6H1C0.448 7 0 7.449 0 8c0 .553.448 1.001 1 1.001h6v6c0 .552.448 1.001 1 1.001s1-.449 1-1.001v-6h6c.552 0 1-.448 1-1.001 0-.553-.448-1.001-1-1.001Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>

</style>